<template>
  <div>
    <div class="boxs">
      <div class="top">
        <p class="p">
          <slot name="title"></slot>
        </p>
        <p class="more">
          <slot name="more"></slot>
        </p>
      </div>
      <div :class="!flag?'contents':'contentsRight'">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Record",
  props: {
    flag: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
@import '../../css/base.less';
@import "../../css/box.less";


</style>
